<template>
  <ion-header class="app-width">
    <ion-toolbar>
      <ion-title>Language Qualification</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <div class="app-width">
    <ion-list>
      <ion-item v-for="qi in langItems" v-bind:key="qi.code" lines="none">
<!--        <template v-if="qi.type === 'year'">-->
<!--          year-->
<!--        </template>-->
<!--        <template v-else-if="qi.type === 'multi-select-card'">-->
<!--          multi-select-card-->
<!--        </template>-->
<!--        <template v-else-if="qi.type === 'select-row'">-->
<!--          select-row-->
<!--        </template>-->
<!--        <template v-else-if="qi.type === 'engcert'">-->
<!--          <quiz-item-english-certification :quiz-item="qi" v-on:answer="qi._answer = $event"></quiz-item-english-certification>-->
<!--        </template>-->
        <template v-if="qi.type === 'engcert'">
          <quiz-item-english-certification :quiz-item="qi" v-on:answer="qi._answer = $event"></quiz-item-english-certification>
<!--          <quiz-item-grade-select :quiz-item="qi" v-on:answer="qi._answer = $event"></quiz-item-grade-select>-->
        </template>
      </ion-item>
    </ion-list>
    </div>
  </ion-content>

  <ion-footer class="app-width">
    <ion-toolbar>
      <ion-button slot="start"  v-on:click="back()">
        <ion-icon :icon="chevronBackOutline"></ion-icon> Back
      </ion-button>
      <ion-button slot="end" v-on:click="proceed()">
        Next <ion-icon :icon="chevronForwardOutline"></ion-icon>
      </ion-button>
    </ion-toolbar>
  </ion-footer>
</template>

<script>
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonFooter,
  IonButton,
  IonIcon,
  IonItem,
  // IonLabel,
  IonList,
  IonContent,
} from '@ionic/vue';
import {
  chevronForwardOutline,
  chevronBackOutline
} from 'ionicons/icons';

import eoppService from "@/mixins/EoppService";
import QuizItemEnglishCertification from "@/enrol/QuizItemEnglishCertification";
import actRouter from "@/account/ActRouter";
// import actRouter from "@/account/ActRouter";

export default {
  name: 'Education',
  components: {
    // QuizItemEnglishCertification,
    QuizItemEnglishCertification,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonFooter,
    IonButton,
    IonIcon,
    IonItem,
    // IonLabel,
    IonList,
    IonContent,
    // QuizItemSelect
  },
  mixins: [eoppService],
  data() {
    return {
      chevronForwardOutline,
      chevronBackOutline,
      langItems:[],
      mirror: true
    };
  },
  mounted() {
    if ( this.lead) {
      this.loadQuizL2();
    } else {
      this.getAccountLead().then(res => {
        console.log(res.data);
        this.$store.commit('leadInfo', res.data);
        this.loadQuizL2();
      })
    }
  },
  methods: {
    back: function () {
      this.setAnswer();
      actRouter.push({ path: '/education' })
    },
    proceed: function () {
      console.log(this.langItems);
      this.setAnswer();
      actRouter.push({ path: '/course-options' })
    },
    setAnswer: function () {
      (this.langItems ||[] ).forEach( o => {
        this.lead.cf.l2[o.code] = o._answer;
        console.log(o._answer);
      })

      this.saveLead();
    },
    loadQuizL2: function () {

      if ( this.lead.cf && this.lead.cf.pref_program) {
        if ( !this.lead.cf.l2 ){
          this.lead.cf.l2 = {}
        }

        let l2Req = {
          email: this.lead.email,
          programCode: this.lead.cf.pref_program
        }

        this.postData('/data/quiz?type=l2', l2Req).then(res => {
          console.log(res)
          if (res.data && res.data.length > 0) {
            this.langItems = res.data.filter( qi => qi.type === 'engcert');
            this.langItems.sort((a, b) => a.order - b.order);
            let idx = 1;
            this.langItems.forEach(o => {
              o.order = idx++;
              o._answer = this.lead.cf.l2[o.code];
            });
          }
        });
      }
    },
    saveLead: function () {
      if (this.lead) {
        console.log(this.lead);
        this.updateCrmRecord([this.lead], null).then(res => {
          console.log(res);
        });
      }
    }
  }
}
</script>
<style>

</style>
